import React from 'react';

import {useAppInitializer} from '@/hooks/useAppInitializer';
import {useIpCheck} from '@/hooks/useIpCheck';

interface AdminRouteGuardProps {
  children: React.ReactNode;
}

const AdminRouteGuard: React.FC<AdminRouteGuardProps> = ({children}) => {
  const isReady = useAppInitializer();
  const {isAllowed, isLoading, clientIp} = useIpCheck();

  if (isLoading && !isReady) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="sr-only">IP 확인 중...</span>
          </div>
          <p className="mt-2">접근 권한을 확인하고 있습니다.</p>
        </div>
      </div>
    );
  }

  if (!isAllowed && isReady) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-6 text-center">
          <div className="text-red-600 mb-4">
            <svg className="w-16 h-16 mx-auto" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M13.477 14.89A6 6 0 015.11 6.524l8.367 8.368zm1.414-1.414L6.524 5.11a6 6 0 008.367 8.367zM18 10a8 8 0 11-16 0 8 8 0 0116 0z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">접근 거부</h1>
          <p className="text-gray-600 mb-4">관리자 페이지는 허용된 네트워크에서만 접근할 수 있습니다.</p>
          <p className="text-sm text-gray-500 mb-6">현재 IP: {clientIp || '확인 불가'}</p>
          <button
            onClick={() => (window.location.href = '/')}
            className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded"
          >
            메인 페이지로 이동
          </button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default AdminRouteGuard;
